<template>
  <div class='model'>
    <mvp :open='open' :type='"model"' :edit='edit'></mvp>
    <div class="items" v-show = 'open'>
      <item v-for="(item,index) in data" :key="index" :data='item' :type='"model"' :edit='edit' :level='1' :list='data' :levelOne = 'item'></item>
    </div>
  </div>
</template>

<script>
import mvp from './components/mvp'
import item from './components/item'

export default {
  name: 'model',
  components: {
    mvp,
    item
  },
  props: {
    edit: {
      type: Boolean
    },
    data: {
      type: Array
    },
    open: {
      type: Boolean
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.model{
  .items{
    float: left;
  }
}
</style>
